import Search from "./scripts/search";
Search().init()

import Modal from "./scripts/modal";
Modal().init()